import { useState } from 'react'
import { Button, Empty, Modal, Table } from '@arco-design/web-react'
import { useQuery } from '@tanstack/react-query'
import { getMissingModelsApi } from '@/api/models'
import ModelFormModal, { type ModelFormSeed } from '@/components/models/ModelFormModal'
import { useBreakpoint } from '@/hooks/useBreakpoint'
import { modalWidth } from '@/utils/responsive'

interface Props {
  visible: boolean
  onCancel: () => void
  onSuccess?: () => void
}

export default function MissingModelsModal({ visible, onCancel, onSuccess }: Props) {
  const { isMobile } = useBreakpoint()
  const [formSeed, setFormSeed] = useState<ModelFormSeed | null>(null)

  const missingQuery = useQuery({
    queryKey: ['models-missing'],
    queryFn: getMissingModelsApi,
    enabled: visible,
    staleTime: 30_000,
  })

  const items = missingQuery.data || []

  const handleCreate = (modelName: string) => {
    setFormSeed({ model_name: modelName, name_rule: 0 })
  }

  const handleFormSuccess = () => {
    missingQuery.refetch()
    onSuccess?.()
  }

  return (
    <>
      <Modal
        title={`未配置模型 (${items.length})`}
        visible={visible}
        onCancel={onCancel}
        footer={null}
        style={{ width: isMobile ? modalWidth(640) : 640 }}
        unmountOnExit
      >
        {missingQuery.isError ? (
          <Empty
            description={
              missingQuery.error instanceof Error
                ? missingQuery.error.message
                : '加载失败'
            }
          />
        ) : (
          <Table
            rowKey={(row) => row}
            loading={missingQuery.isLoading}
            data={items}
            pagination={items.length > 10 ? { pageSize: 10 } : false}
            noDataElement={
              <Empty description="所有已启用渠道模型均已配置元数据" />
            }
            columns={[
              {
                title: '模型名称',
                dataIndex: 'model_name',
                render: (_: unknown, name: string) => (
                  <span className="font-mono text-sm">{name}</span>
                ),
              },
              {
                title: '操作',
                width: 100,
                render: (_: unknown, name: string) => (
                  <Button type="text" size="small" onClick={() => handleCreate(name)}>
                    创建
                  </Button>
                ),
              },
            ]}
          />
        )}
      </Modal>

      <ModelFormModal
        visible={!!formSeed}
        seed={formSeed}
        onCancel={() => setFormSeed(null)}
        onSuccess={handleFormSuccess}
      />
    </>
  )
}
